import type { Category, Collection } from '../types/product'
import { images } from './images'

export const categories: Category[] = [
  { id: 'sets', title: 'Sets' },
  { id: 'reiniging', title: 'Reiniging' },
  { id: 'scrubtools', title: 'Scrubtools' },
  { id: 'olien', title: 'Oliën' },
  { id: 'bloemenwater', title: 'Bloemenwater' },
  { id: 'make-up-haar', title: 'Make-up & haar' },
  { id: 'geur', title: 'Geur' },
]

export const collections: Collection[] = [
  {
    slug: 'voor-haar',
    title: 'Voor haar',
    intro: 'Van zwarte zeep tot cactusvijgolie: het volledige ritueel voor huid en haar.',
    kind: 'audience',
    value: 'haar',
    image: images.hero,
  },
  {
    slug: 'voor-hem',
    title: 'Voor hem',
    intro: 'Hammam-reiniging, olie voor huid en baard, en geuren met karakter.',
    kind: 'audience',
    value: 'hem',
    image: images.him,
  },
  {
    slug: 'bestsellers',
    title: 'Bestsellers',
    intro: 'De producten waar onze klanten steeds weer voor terugkomen.',
    kind: 'badge',
    value: 'bestseller',
    image: images.argan,
  },
  {
    slug: 'nieuw',
    title: 'Nieuw',
    intro: 'Net binnen uit Marokko.',
    kind: 'badge',
    value: 'nieuw',
    image: images.cactus,
  },
  {
    slug: 'cadeaus',
    title: 'Cadeaus',
    intro: 'Sets en geuren in cadeauverpakking. Gratis kaartje met je eigen tekst.',
    kind: 'badge',
    value: 'cadeau',
    image: images.giftset,
  },
  {
    slug: 'alles',
    title: 'Alle producten',
    intro: 'Het complete assortiment pure Marokkaanse verzorging.',
    kind: 'all',
  },
]
